import React from 'react';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { number, func } from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import {
  useDataModel,
  params,
  string,
  shape
} from '@thd-nucleus/data-sources';
import { useCabinetVisualizerStore } from '../../../store';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export const WallPriceProduct = ({ itemId, quantity, handleRemove, type }) => {
  const { storeId = '121' } = useStore();
  const { updateCabinetVisualizer, cabinetVisualizer: { itemPrices,
    styleChoiceId } } = useCabinetVisualizerStore((state) => state);

  const { data: productData } = useDataModel('product', {
    variables: { itemId, storeId },
    ssr: false,
    skip: !itemId
  });

  const product = productData?.product;

  if (product && !product?.pricing) {
    logNewRelicCustom(NEW_RELIC_EVENTS.PRICE_PRODUCT_LOOKUP_FAIL, { itemId, storeId, styleChoiceId });
  }
  const name = product?.identifiers?.productLabel;
  const productPrice = product?.pricing?.value;
  const price = quantity * (Number(productPrice) || 0);

  if (productPrice && !itemPrices.find((item) => item.itemId === itemId)) {
    updateCabinetVisualizer({
      itemPrices: [
        ...itemPrices,
        {
          itemId,
          // Data we need for price summations
          price: productPrice,
          // Data we need for discount display and ATC
          storeSkuNumber: product.identifiers?.storeSkuNumber,
          strikeThroughProduct: {
            pricing: {
              cartItem: {
                total: price,
              },
              original: product?.pricing?.original || productPrice,
              value: productPrice,
              promotion: {
                message: 'Save ',
                percentageOff: product.pricing?.promotion?.percentageOff,
              },
            },
          }
        }
      ]
    });
  }

  return productData ? (
    <div
      data-component="wallprice-product"
      id={`WallPriceSummary_${itemId}`}
      className="sui-flex sui-justify-between line-item"
    >
      <div>
        <Typography
          style={{ color: '#5E5E5E', marginRight: '0.4rem' }}
          variant="body-small"
        >
          {`(${quantity})`}
        </Typography>
      </div>
      <div className="product-description sui-flex-grow-1">
        <Typography
          variant="body-small"
          align="left"
          style={{ color: '#5E5E5E', marginRight: '20%' }}
        >
          {name || 'Product Name'}
        </Typography>

        {type !== 'Cabinets' && ( // Conditionally render the button
          <Button variant="text" onClick={handleRemove}>
            <Typography variant="body-xs">
              Remove
            </Typography>
          </Button>
        )}

      </div>
      <div className="price-container sui-flex sui-justify-end">
        <Typography
          variant="body-small"
          style={{ color: '#5E5E5E' }}
        >
          <span>
            ${price?.toFixed(2) || '0.00'}
          </span>
        </Typography>
      </div>
    </div>
  ) : (
    <span>Loading...</span>
  );
};

WallPriceProduct.propTypes = {
  itemId: number.isRequired,
  quantity: number.isRequired,
  handleRemove: func,
  type: string
};

WallPriceProduct.dataModel = {
  product: params({ itemId: string().isRequired(), dataSource: string() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      productLabel: string()
    }),
    pricing: shape({
      value: string(),
      original: string()
    }),
  })
};

WallPriceProduct.defaultProps = {
  handleRemove: () => {},
  type: ''
};